import {
  AlertRuleType,
  AlertRule,
  CompRiskLevel,
  AlertRuleDirection,
} from '@/api';
import { RiskKeys } from '@/config';
export const selectPopupStyles = {
  popup: { root: { zIndex: 10000 } },
} as const;
export const ALERT_NAME_MAX_LENGTH = 250;

export type AlertGradeOption = {
  label: string;
  value: CompRiskLevel;
};

export type AlertDirectionOption = {
  label: string;
  value: AlertRuleDirection;
};

export type AlertEntityTypeOption = {
  label: string;
  value: RiskKeys;
};

export const DEFAULT_TX_COUNT_RULE: AlertRule = {
  name: '',
  type: AlertRuleType.TX_COUNT,
  risk: CompRiskLevel.Low,
  direction: 'income',
  categories: [RiskKeys.MERCHANT_SERVICES],
  categoryJoin: 'all',
  params: {
    count: 0,
    intervalType: 'minute',
    intervalValue: 0,
    minAmount: 0,
    maxAmount: 0,
  },
};

export const DEFAULT_COMMON_RULE: AlertRule = {
  name: '',
  type: AlertRuleType.COMMON,
  risk: CompRiskLevel.Low,
  direction: 'income',
  categories: [RiskKeys.MERCHANT_SERVICES],
  categoryJoin: 'all',
  params: {},
};
